import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Label,
  Card,
  Input,
  FormFeedback
} from "reactstrap";
import Select from "react-select";
import i18n from "../../../i18n";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getOrgsAdmin  } from "../../../helpers/api_rombo_helper";

const Step1 = ({ step, setStep, setName, setPhone, setEmail, name, phone, email, token, setLastName, lastName, setSecondLastName, secondLastName, setCompany, company, setIsRole, isRole, infoUser, setErrorAlert, setErrorAlertMessage }) => {

  const dispatch = useDispatch()
  const [emailValid, setEmailValid] = useState(false);
  const [phoneValid, setPhoneValid] = useState(false);
  const [listCompanies, setListCompanies] = useState([]);
  const [listTypeUser, setTypeUser] = useState([]);

  useEffect(() => {
    onGetOrgsAdmin()
    formatTypeUser()
    fillCompany()
  }, [dispatch]);

  const onGetOrgsAdmin = () => {
    let arr = []
    getOrgsAdmin(token)
      .then((response) => {
        response.map((item) => {
          arr.push({ label: item.name, value: item.name })
        })
        setListCompanies([...arr])
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message))
      })
  }

  const fillCompany = () => {
    infoUser.is_staff ? null : setCompany({ label: infoUser.partner_name, value: infoUser.partner_id })
  }

  const formatTypeUser = () => {
    let arr = []
    // infoUser.is_staff ? arr.push({ label: i18n.t("IsStaff"), value: "STAFF" }) : null
    // arr.push({ label: i18n.t("IsUser"), value: "USER" })
    arr.push({ label: i18n.t("IsAdmin"), value: "ADMIN" })
    setTypeUser([...arr])
  }

  const onClickNextStep = () => {
    if (name && email && phone && isRole) {
      setErrorAlertMessage(null);
      setErrorAlert(false);
      setStep(step + 1);
    } else {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
    }
  };
  
  const onBlurPhone = (newPhone) => {
    if (!newPhone.match('[0-9]{10}')) {
      setPhoneValid(true);
    } else {
      setPhoneValid(false);
      setPhone(newPhone);
    }
  };
  

  return (
    <Fragment>
      <CardBody>
        <Row>
          {infoUser.is_staff && (
            <Col xxl={6} md={6} xs={12}>
              <h6 className="employees-form-title" htmlFor="companyNameInput">
                {i18n.t("Partner")}
              </h6>
              <p className="employees-form-text">{i18n.t("DescSelectPartner")}</p>
              <Card>
                <Select
                  name="company"
                  placeholder={i18n.t("SelectPartnerName")}
                  options={listCompanies}
                  className="select2-selection"
                  value={company}
                  isDisabled={true}
                />
              </Card>
              <div className="request-separator" />
            </Col>
          )}
          <Col xs={12} xxl={12} xl={12} className="pb-3">
            <h6 className="employees-form-title">{i18n.t("DataUser")}</h6>
            <p className="employees-form-text">{i18n.t("DescUser")}</p>
          </Col>
          <Row>
          <Col xs={12} xxl={6} xl={4} className="">
            <Label className="employees-form-subtitle" htmlFor="nameInput">
              {i18n.t("DisplayName")}
            </Label>  
            <Input
              type="text"
              name="name"
              value={name}
              className="employees-form-input"
              id="nameInput"
              onChange={(e) => setName(e.target.value)}
              placeholder={i18n.t("UserName")}
            />
          </Col>
          </Row>
          <Row>
          <Col xs={12} xxl={3} xl={4} className="pt-2">
            <Label className="employees-form-subtitle" htmlFor="emailInput">
              {i18n.t("Email")}
            </Label>  
            <Input
              type="email"
              name="email"
              value={email}
              disabled={true}
              className="employees-form-input"
              id="emailInput"
              onChange={(e) => setEmail(e.target.value)}
              placeholder={i18n.t("UserEmail")}
            />
            {emailValid && (
              <FormFeedback type="invalid" className="error-message">
                <i className="fa fa-exclamation-circle"></i>
                {i18n.t("EmailInvalid")}
              </FormFeedback>
            )}
          </Col>
          <Col xs={12} xxl={3} xl={4} className="pt-2">
            <Label className="employees-form-subtitle" htmlFor="phoneInput">
              {i18n.t("Phone")}
            </Label>  
            <Input
              type="text"
              name="phone"
              defaultValue={phone}
              className="employees-form-input"
              minLength={10}
              maxLength={10}
              id="phoneInput"
              onBlur={(e) => onBlurPhone(e.target.value)}
              placeholder={i18n.t("UserPhone")}
            />
            {phoneValid && (
              <FormFeedback type="invalid" className="error-message">
                <i className="fa fa-exclamation-circle"></i>
                {i18n.t("PhoneInvalid")}
              </FormFeedback>
            )}
          </Col>
          </Row>
          <Col xxl={12} md={6} xs={12}>
            <div className="request-separator" />
          </Col>
          <Col xxl={12} md={4} xs={4}></Col>
          {infoUser.is_staff && (
            <Col xxl={4} md={4} xs={12} className="pt-2">
              <h6 className="employees-form-title">{i18n.t("TypeUser")}</h6>
              <p className="employees-form-text">{i18n.t("DescTypeUser")}</p>
              <Card>
                <Select
                  name="typeUser"
                  placeholder={i18n.t("NotAssigned")}
                  options={listTypeUser}
                  className="select2-selection"
                  value={listTypeUser.filter((ele) => ele.value == isRole)}
                  onChange={(e) => setIsRole(e.value)}
                />
              </Card>
            </Col>
          )}
          <Col xxl={12} md={12} xs={12} className="pt-2 d-flex">
            <button onClick={() => onClickNextStep()} className="btn btn-request">
              {i18n.t("NextStep")}
            </button>
            <Link to={"/users"} className="btn btn-go-back mx-2">
              {i18n.t("Back")}
            </Link>
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  )
}

export default Step1;
